import React from 'react';

import Icon from '@components/Icon/Icon';

export default function RoundedArrowButton({
  onClick,
  rotation = 0,
  color = 'primary.contrastText',
}: {
  onClick?: () => void;
  rotation?: number;
  color?: string;
}) {
  function handleClick() {
    if (onClick) {
      onClick();
    }
  }

  return (
    <Icon
      clickable
      color={color}
      name="circle-chevron-down"
      onClick={handleClick}
      rotation={rotation}
      style={{ fontSize: 32, marginTop: 0 }}
    />
  );
}
